import { z } from 'zod'

export const UserCreateSchema = z.object({
  username: z.string(),
  password: z.string(),
  confirmPassword: z.string(),
  department: z.string().optional(),
})

export type UserCreateModel = z.infer<typeof UserCreateSchema>

export const UserUpdateSchema = z.object({
  id: z.number(),
  username: z.string(),
  name: z.string(),
  department: z.string().optional().nullable(),
  roles: z.array(z.string()),
  groups: z.array(z.string()),
})

export type UserUpdateModel = z.infer<typeof UserUpdateSchema>

export const UserChangePasswordSchema = z.object({
  id: z.number(),
  password: z.string(),
  confirmPassword: z.string(),
})

export type UserChangePasswordModel = z.infer<typeof UserChangePasswordSchema>

export const ChangeOwnPasswordSchema = z.object({
  currentPassword: z.string(),
  newPassword: z.string(),
})

export type ChangeOwnPasswordModel = z.infer<typeof ChangeOwnPasswordSchema>
